<template>
    <v-app-bar app height="80" >
        <v-spacer></v-spacer>
        <v-toolbar-title class="title-fixed">
            <img :src="randomImage" alt="Logo" class="logo" />
        </v-toolbar-title>


        <v-tabs class="tabs-limited" centered center-active>
            <v-tab
                v-for="link in filteredLinks"
                :key="link.id" 
                :to="link.route"
                @click="goAction(link.action)"
            >
                {{ link.title }}
            </v-tab>
        </v-tabs>

        <v-spacer></v-spacer>
        <v-divider
            vertical
            class="mx-4"
        ></v-divider>
        <span>Language:</span>

        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
                <span :class="`flag-icon flag-icon-${currentLanguage.flag}`"></span>
            </v-btn>
            </template>
            <v-list>
            <v-list-item
                v-for="lang in languages"
                :key="lang.code"
                @click="changeLanguage(lang.code)"
            >
                <v-list-item-avatar>
                <i :class="`flag-icon flag-icon-${lang.flag}`"></i>
                </v-list-item-avatar>
                <v-list-item-content>
                <v-list-item-title>{{ lang.name }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            </v-list>
            
        </v-menu>
        <v-divider
            vertical
        ></v-divider>
        <v-spacer></v-spacer>
    </v-app-bar>

</template>		

<script>
import Vue from "vue";
import axios from 'axios';

export default {
  name: 'AppNavBar',
  props: {
  },
  data: () => ({    
	account_id: 0,
    group_id: 0,
	credit: 0,
	cashpoints: 0,
	user_name: '',
	my_refcode: '', //codigo de quien me invito
	reference: '', //codigo con que invito a otros
	token: '',
    name: 'Welcome',
	showlogin: true,
    email: '',
    status: false,
    drawer: true,
    mini: true,
    isLoading: false,
    model: null,
    search: '',
    showLoginDialog: false,
    showDialogManager: false,
    showDialogAnnounce: false,
    items_search: [],
    categorias:  [],
	
    links_headers: [
		{  id: 1, need_login: 0, title: 'Main', action: 'home', route: '/' },
		{  id: 2, need_login: 0, title: 'Information',  action: 'information', route: '/serverinfo' },
		{  id: 3, need_login: 0, title: 'Discord',  action: 'discord', route: 'https://discord.gg/ppMyV4e' },
		{  id: 4, need_login: 0, title: 'Wiki',  action: 'wiki', route: '/wiki' },
		{  id: 5, need_login: 0, title: 'Download',  action: 'download', route: '/downloads' },
		//{  id: 4, need_login: 0, title: 'Ranking',  action: 'ranking', route: '/ranking' },
		//{  id: 5, need_login: 0, title: 'Deathlog',  action: 'deathlog', route: '/deathlog' },
		//{  id: 6, need_login: 1, title: 'Shop',  action: 'cashshop', route: '/cashshop' },
		//{  id: 7, need_login: 0, title: 'Market',  action: 'Market', route: '/market' },
		{  id: 6, need_login: 0, title: 'Stream',  action: 'stream', route: '/' },
		{  id: 7, need_login: 0, title: 'Press Kit',  action: 'presskit', route: '/' }
  	],
	locales: ['en', 'es'],
	currentLocale: 'en',
	languages: [
		{ code: 'en', name: 'English', flag: 'us' },
        { code: 'es', name: 'Español', flag: 'es' },
        { code: 'pt', name: 'Português', flag: 'pt' },
        { code: 'fil', name: 'Filipino', flag: 'ph' },
      ],
	  images: [
        "/assets/imgs/logo/logo_01.png",
        "/assets/imgs/logo/logo_01.png"
      ],
      randomImage: "",
  }),
  mounted() {
	this.randomImage = this.images[Math.floor(Math.random() * this.images.length)];
    },
    
    
  methods: {
	changeLanguage(lang) {
        this.$emit('emit_changeLanguage',lang);
    },
	goAction(action) {
        this.$emit('emit_action',action);
    },
  },
  computed: {
    currentLanguage() {
      return this.languages.find(lang => lang.code === this.$i18n.locale);
    },
	filteredLinks() {
		return this.links_headers.filter(link => {
		return link.need_login === 0 || (link.need_login === 1 && this.account_id > 0);
		});
	}
  },
};
</script>